import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { DateValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers/models'

type Props = Omit<DatePickerProps<Date>, 'value' | 'onChange'> & {
    value: Date | null
    onChange?: (
        value: Date | null,
        context: PickerChangeHandlerContext<DateValidationError>
    ) => void
}

export default function ThaiDatePicker(props: Props) {
    const { value, onChange, ...rest } = props
    
    return (
        <DatePicker
            {...rest}
            value={value}
            onChange={onChange}
            format="dd/MM/yyyy" 
        />
    )
}
